import { useEffect, useState } from 'react';

/** «Скопировать» (BotCore.copyBtn): галочка «Скопировано» на месте подписи 1,6 с; буфер недоступен — текст блока выделен и подсказка. */
export function useTextCopy() {
  const [done, setDone] = useState<string | null>(null);
  const [failed, setFailed] = useState<string | null>(null);
  useEffect(() => {
    if (!done) return;
    const timer = window.setTimeout(() => setDone(null), 1600);
    return () => clearTimeout(timer);
  }, [done]);
  async function copy(id: string, text: string, node?: Element | null) {
    setFailed(null);
    try {
      if (!navigator.clipboard?.writeText) throw new Error('clipboard_unavailable');
      await navigator.clipboard.writeText(text);
      setDone(id);
    } catch {
      setDone(null);
      setFailed(id);
      if (node) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(node);
        selection?.removeAllRanges();
        selection?.addRange(range);
      }
    }
  }
  return { copy, done, failed };
}
/** Скачать текст файлом TXT (BotCore.saveBtn) */
export function downloadText(text: string, name: string) {
  const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  anchor.rel = 'noopener';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
